import { Modal } from "@common/Modal";
import i18n from "@service/locale/i18";

export const tryUnload = async (title: string) => {
    const modal = new Modal({
        title: title,
        buttons: [
            {
                text: i18n.t('common.yes').toString(),
                class: 'is-green',
                returnValue: true
            },
            {
                text: i18n.t('common.no').toString(),
                class: 'is-red is-outlined',
                returnValue: false
            },
        ]
    });

    const confirmed = await modal.showConfirm() as boolean | "close";

    return confirmed === 'close' ? false : confirmed;
}